// FLAG:useDocuAi — pure helper for the document drawer's analysed-event tag
// handling. Kept dependency-free so it is unit-testable without the store/ESM
// import graph.
//
// When useDocuAi auto-classified the Art (the worker sent `autoClassifiedAs`),
// drop the stale system tag so the drawer refetch adopts the freshly classified
// one. Otherwise — flag OFF, or no auto-classification — preserve the current
// system tag, which is the baseline behaviour. With the flag off this always
// returns the baseline value, so it is inert by construction.
export const resolveAnalysedPreserveTags = ({ useDocuAiEnabled, autoClassifiedAs, currentKind }) => {
  if (useDocuAiEnabled && autoClassifiedAs) {
    return []
  }
  return currentKind ? [currentKind] : []
}
